import React from "react";
import { Select } from "@assets/spa/control/select";
export function ForminatorSelect(props) {
    const { placeholder, onChange, value, options, } = props;
    return React.createElement(Select, { value: value, onChange: onChange, placeholder: placeholder, options: options });
}
